import { useState } from 'react';

export const useKanbanCardInfo = (initialItems = []) => {
  const [cardFields, setCardFields] = useState(initialItems);

  const handleToggleCardField = (key) => {
    if (key === 'resetToInitial') {
      setCardFields(initialItems);
      return;
    }
    setCardFields((prev) =>
      prev.map((item) =>
        item.key === key ? { ...item, active: !item.active } : item
      )
    );
  };

  return { cardFields, handleToggleCardField };
};

export default useKanbanCardInfo;
